import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const MarsdenPark = () => (
  <CostcoLocationTemplate
    warehouseName="Marsden Park"
    suburb="Marsden Park"
    state="New South Wales"
    stateShort="NSW"
    address="Hollinsworth Rd, Marsden Park NSW 2765"
    path="/costco/marsden-park"
    nearbySuburbs={[
      'Marsden Park',
      'Schofields',
      'Riverstone',
      'Quakers Hill',
      'Colebee',
      'Rouse Hill',
      'The Ponds',
      'Stanhope Gardens',
      'Kellyville',
      'Box Hill',
    ]}
    description="Serving Costco Executive Members near the Marsden Park warehouse in Sydney's North-West growth area. With thousands of new homes being built across this corridor, our team helps buyers and homeowners secure competitive loans — and earn a Costco Shop Card when your loan settles."
    localContext={[
      {
        title: 'North-West Growth Area',
        description:
          'Marsden Park sits at the heart of one of Sydney\'s largest residential release areas. New estates across Marsden Park, Box Hill, and Schofields are attracting young families and first home buyers with modern homes and community infrastructure.',
      },
      {
        title: 'New Estates & House-and-Land Packages',
        description:
          'The North-West corridor offers a wide range of house-and-land packages. Lenders assess these differently to established properties, and our brokers specialise in helping buyers navigate construction loans and progress payment schedules.',
      },
      {
        title: 'Aerotropolis & Airport Proximity',
        description:
          'The Western Sydney Aerotropolis and upcoming Western Sydney International Airport are expected to generate tens of thousands of jobs in the region, driving sustained demand for housing across the North-West corridor.',
      },
    ]}
    faqs={[
      {
        q: 'Can I get a Costco Shop Card on a construction loan for a new build in Marsden Park?',
        a: 'Yes. Construction loans that settle through Manage Your Loans are eligible for the Costco Shop Card offer. The Shop Card value is based on the fully drawn-down loan amount once all progress payments are complete. You must be a Costco Executive Member at settlement.',
      },
      {
        q: 'What should I know about buying in a new estate near Marsden Park?',
        a: 'New estates often require construction loans with staged progress payments rather than a standard home loan. It\'s important to understand builder timelines, sunset clauses, and how lenders assess land-and-build contracts. Our brokers have extensive experience in the North-West growth corridor.',
      },
      {
        q: 'How does the Shop Card value scale with my loan amount?',
        a: 'The Costco Shop Card value increases with your loan size. For example, a $100k loan earns a $200 Shop Card, a $900k loan earns $1,800, and loans of $2M or more earn up to $4,000. The value is based on the fully drawn-down amount — offset and redraw balances are excluded.',
      },
      {
        q: 'Are there any first home buyer advantages in the North-West?',
        a: 'Yes. Many buyers in the North-West qualify for the NSW First Home Buyer Assistance Scheme, the First Home Owner Grant for new builds, and the federal First Home Guarantee. These can be combined with the Costco Shop Card offer when you settle through Manage Your Loans.',
      },
    ]}
    suburbData={{
      suburb: 'Marsden Park',
      medianHouse: '$920,000',
      medianUnit: '$550,000',
      daysOnMarket: '25 days',
      rentalYield: '3.3%',
      population: '15,000',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Schofields', medianHouse: '$950,000', medianUnit: '$560,000', daysOnMarket: '23 days' },
      { suburb: 'Riverstone', medianHouse: '$880,000', medianUnit: '$520,000', daysOnMarket: '26 days' },
      { suburb: 'Quakers Hill', medianHouse: '$920,000', medianUnit: '$540,000', daysOnMarket: '24 days' },
      { suburb: 'Colebee', medianHouse: '$980,000', medianUnit: '$570,000', daysOnMarket: '22 days' },
      { suburb: 'Rouse Hill', medianHouse: '$1,150,000', medianUnit: '$620,000', daysOnMarket: '21 days' },
      { suburb: 'The Ponds', medianHouse: '$1,080,000', medianUnit: '$590,000', daysOnMarket: '20 days' },
      { suburb: 'Stanhope Gardens', medianHouse: '$1,020,000', medianUnit: '$560,000', daysOnMarket: '25 days' },
      { suburb: 'Kellyville', medianHouse: '$1,350,000', medianUnit: '$680,000', daysOnMarket: '19 days' },
      { suburb: 'Box Hill', medianHouse: '$1,050,000', medianUnit: '$580,000', daysOnMarket: '22 days' },
    ]}
  />
);

export default MarsdenPark;
